// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3ufy6","header":"ReportDetails_header__20jB9","title":"ReportDetails_title__RNi96","left":"ReportDetails_left__2zdK6"};